import * as navigation from 'Navigation';

/**
 * An alternative to ReviewTabState that is GraphQL-based.
 */
class ReviewHistoryTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Review',
      closeable: false,
      options: false,
      preferenceKey: 'review',
    };
  }
}

export default ReviewHistoryTabState;
